import { render, staticRenderFns } from "./page-account.vue?vue&type=template&id=6f772504"
import script from "./page-account.vue?vue&type=script&lang=js"
export * from "./page-account.vue?vue&type=script&lang=js"
import style0 from "./page-account.vue?vue&type=style&index=0&id=6f772504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports